import axios from "axios";
import { getSessionToken } from "../../utils/Auth/AuthUtils";

const API_URL = "/api/user";

//Login a user
const login = async () => {
  const token = await getSessionToken();
  const headers = {
    "Content-Type": "application/json",
    authorization: token,
  };
  const response = await axios.post(API_URL + "/login", headers, { headers }); //calls backend login API
  return response.data;
};

//Logout user
const logout = () => {
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("role");
  sessionStorage.clear();
};

const authService = { logout, login };

export default authService;
